import { render } from "./FilesTable.vue?vue&type=template&id=c9cb642c"
import script from "./FilesTable.vue?vue&type=script&lang=js"
export * from "./FilesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__